export default __webpack_public_path__ + "static/Integrated-Imunology-Clinic-min-32b01b0add7a229be60d30bc5f64be03.pdf";